export function countRatio(height?: number, width?: number) {
    if (!height || !width) {
        return undefined;
    }

    if (height <= 0) {
        return undefined;
    }
    if (width <= 0) {
        return undefined;
    }

    return (height / width) * 100;
}
